<template>
  <div class="vx-col w-full lg:w-1/3 sm:w-full mb-base">
    <vx-card>
      <span class="title-head">{{ title }}</span><br>
      <div class="vx-row flex mt-20">
        <span class="vx-col flex-1 text-left label">ยอดชำระ</span>
        <div class="vx-col flex-1 text-right"><span class="money-bold">{{ amount | numberFormat }} </span> <span class="label-bold">บาท</span></div>
      </div><br>
      <vs-button type="filled" class="w-full" color="primary"  @click="btnQrPayment(type, 0)">ชำระเงิน</vs-button>
    </vx-card>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex'
import {IQrPaymentType} from "@/constants/interface";
const { mapState: mapAccountingState } = createNamespacedHelpers('Accounting')

export default {
  name: "PaymentExpense",
  props: {
    btnQrPayment: Function,
    type: String,
  },
  computed: {
    ...mapAccountingState(['status', 'paymentAmountDetailNormal', 'paymentAmountDetailOutstanding', 'paymentRoundDetail', 'contract', 'loan', 'qrPayment']),
    title(){
      return "ชำระ"+this.$options.filters.qrPaymentTypeName(this.type);
    },
    amount(){
      const { contractFeeRemain, taxAmountRemain, processingFeeRemain, courtOrderExpenseRemain } = this.loan;
      if(this.type === IQrPaymentType.contractFee){
        return contractFeeRemain;
      }else if(this.type === IQrPaymentType.taxAmount){
        return taxAmountRemain;
      }else if(this.type === IQrPaymentType.processingFee){
        return processingFeeRemain;
      }else if(this.type === IQrPaymentType.courtOrderExpense){
        return courtOrderExpenseRemain;
      }
    },
  },
}
</script>

<style scoped>

</style>


